import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { Modal } from "react-bootstrap";
import { get } from "lodash";

interface IDropDownOption {
  titulo: string;
  value: string | number;
}

interface IFormInputDropDownProps {
  name: string;
  label?: string;
  placeholder?: string;
  options?: IDropDownOption[];
  required?: string;     // Si viene con texto → required activado
  modal?: string;        // Contenido del modal
  xl?: number;
  md?: number;
  col?: number;
}

const FormInputDropDown: React.FC<IFormInputDropDownProps> = ({
  name,
  label,
  options,
  required,
  modal,
  xl = 12,
  md = 12,
  col = 12,
  placeholder,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // ERROR
  const errorMessage = get(errors, name)?.message as string | undefined;

  ////// MODAL //////
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <div className={`col-xl-${xl} col-md-${md} col-${col}`}>
      <div className={`input-block ${errorMessage ? "error" : ""}`}>

        {(label || modal) && (
          <div className="d-flex align-items-center gap-1">
            {label && (
              <label htmlFor={name} className="input-block__label mb-0">
                {label}
              </label>
            )}

            {modal && (
              <TooltipComponent content="Más información">
                <div onClick={handleShow} className="information-icon-orange p-0" />
              </TooltipComponent>
            )}
          </div>
        )}

        <select
          id={name}
          className="form-select"
          {...register(name, {
            required: required ? required : false,
          })}
          defaultValue={""}
        >
          <option value={""}>{placeholder ?? "Selecciona una opción"}</option>

          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.titulo}
            </option>
          ))}
        </select>

        {errorMessage && <p className="error m-0">{errorMessage}</p>}

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modal}</Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default FormInputDropDown;
